import { find, map } from 'lodash'
import type { DocumentNode } from '@apollo/client/core';

import { queryBase } from './queryBase'

function createVariablesWrapper(originalVars, skip=null){

    let previousVariables: string;

    return function() {

        let shouldSkip = false;

        if(skip){

            if(typeof skip === 'function'){
                shouldSkip = skip.bind(this)();
            }
            else {
                shouldSkip = skip;
            }
        }

        // Return previous variables in order to skip query fetch
        if(shouldSkip){
            return previousVariables;
        }

        const result = originalVars.bind(this)();
        previousVariables = result;

        return result;
    }
}

export function createQuery(document: DocumentNode, options=null) {

    const query: any = find(document.definitions, { operation: 'query' });

    // Default variables
    const variableNames = map(query.variableDefinitions, 'variable.name.value');

    let variables: any = {};
    variableNames.forEach(variable => {
        variables[variable] = null;
    });

    if(options?.variables){

        // Wrap in wrapper function for apollo bugfix (skip called after query)
        if(typeof options.variables === 'function'){
            variables = createVariablesWrapper(options.variables, options.skip);
        }
        else {
            variables = options.variables;
        }
    }

    // Update response
    const selectionSet = query.selectionSet.selections;
    if(selectionSet.length === 0){
        throw 'No selection found';
    }

    const firstSelectionName = selectionSet[0].name.value;

    const queryObject = {

        ...queryBase,

        query: document,
        update: (data) => data ? data[firstSelectionName] : null,
        result(response) {

            if(response && response.data && response.data[firstSelectionName]){

                if(queryObject.response){
                    const boundResponse = queryObject.response.bind(this);
                    boundResponse(response.data[firstSelectionName], response);
                }
            }
            else if(queryObject.emptyResponse){

                const boundEmptyResponse = queryObject.emptyResponse.bind(this);
                boundEmptyResponse(response);
            }
        },
        response: null,

        ...(options || {}),

        variables
    };

    return queryObject;
}